// SiteUp: dica ancorada por página do Hub. Fonte única do PageCoach.
// Toda rota alcançável por hubWorlds.js precisa de entrada aqui
// (o spec de cobertura falha se faltar).
// A dica é VERSIONADA: guardar a versão vista, não booleano.
// `sourceGlobs`: caminhos cuja mudança no CI exige bump ou declaração
// `onboarding-sem-impacto: <key>: <motivo>`.
//
// COMO BUMPAR quando a tela mudar (é isto que o gate de CI procura):
// passe o 5º argumento com `version` e `whatsNewKey` escritos na própria
// chamada, para que fiquem visíveis no texto do arquivo. O validador
// `.github/scripts/onboarding_impact_check.js` lê o registro como TEXTO
// (nunca executa o módulo), então versão escondida dentro do helper não
// é enxergada e o CI reprova o PR mesmo com o bump feito.
//
//   tasks: page('tasks', 'sales', [ancoras], [globs], {
//     version: 2,
//     whatsNewKey: 'ONBOARDING.PAGES.TASKS.WHATS_NEW',
//   }),

import { HUB_WORLDS } from 'dashboard/routes/dashboard/hub/hubWorlds';

const page = (
  routeName,
  world,
  anchors = [],
  sourceGlobs = [],
  overrides = {}
) => ({
  key: routeName,
  version: 1,
  titleKey: `ONBOARDING.PAGES.${routeName.toUpperCase()}.TITLE`,
  bodyKey: `ONBOARDING.PAGES.${routeName.toUpperCase()}.BODY`,
  manualKey: `ONBOARDING_MANUAL.${routeName.toUpperCase()}`,
  whatsNewKey: null,
  world,
  sourceGlobs,
  ...(anchors.length ? { anchors } : {}),
  ...overrides,
});

export const PAGE_COACH = Object.freeze({
  ai_center: page(
    'ai_center',
    'ai_center',
    ['[data-testid="ai-center"]'],
    [
      'app/javascript/dashboard/routes/dashboard/aiCenter/**',
      'app/javascript/dashboard/routes/dashboard/hub/hubWorlds.js',
    ],
    // v4: Social selling mostra o tipo do comentário, a checagem e quem está
    // respondendo; as configurações ganham as regras por tipo.
    // v5: cada tipo pode responder sozinho, com limite por hora.
    // v6: Oportunidades mostram a situação que o JEV identificou, com regra por situação.
    // v7: lead de anúncio do WhatsApp oficial ganha template na janela grátis.
    // v8: formato da retomada por caixa (nota ou sugestão no campo de resposta).
    // v9: situação que retoma sozinha se ninguém mexer, com carência e limite por hora.
    // v10: movimentação do Kanban mostra a regra usada (do funil ou padrão da conta)
    // e avisa quando a atualização não mudou a etapa.
    // v11: Conversões de anúncios ganham "Reenviar evento" para o administrador.
    // v12: pendentes em cada aba; área desligada diz o que falta, ligada mostra a saúde.
    // v13: aba Ligações com nota e critérios da IA; administrador ajusta os pesos.
    // v14: Configurar em modos prontos (Acompanhamento, Social, Ligações) e Descartar.
    // v15: Brasa digital no cabeçalho; Configurar vira tela própria, sem rolar até as abas.
    // v16: redesign da Central. Cada área, item e categoria dos Ajustes tem
    // página própria (voltar do navegador funciona); Social selling vira
    // Comentários e Oportunidades vira Retomadas; a configuração sai da
    // Central e vai para Ajustes da IA; o Hub abre cada área pelo endereço novo.
    // v17: comentário em post de imóvel mostra o cartão "Imóvel do post" (com
    // troca entre candidatos) e Ajustes de Comentários ganham Catálogo de imóveis.
    // v18: identidade Visor. Oportunidades ganham o bloco em degradê com o
    // cartão de Dica em carrossel; trilho e abas dos Ajustes com ícones Solar,
    // blocos com borda e raios por papel.
    // v18: Ajustes de Imóveis ganham a Marca da imobiliária usada nas sugestões.
    // v18: Comentários separa o que a automação da campanha respondeu do que a
    // equipe ou a IA enviou, e diz quem enviou.
    {
      version: 18,
      whatsNewKey: 'ONBOARDING.PAGES.AI_CENTER.WHATS_NEW',
    }
  ),
  settings_menu: page(
    'settings_menu',
    'system',
    ['[data-testid="settings-center"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/SettingsCenter.vue',
      'app/javascript/dashboard/routes/dashboard/settings/settingsCatalog.js',
      'app/javascript/dashboard/routes/dashboard/settings/settingsContext.js',
    ],
    // v4: o voltar diz o destino e leva para a tela de onde a pessoa veio.
    // v5: card de funil travado diz o motivo; item Plano; busca unificada.
    // v6: o item Central da IA vira Ajustes da IA e abre a configuração da IA
    // por categoria (redesign da Central).
    { version: 6, whatsNewKey: 'ONBOARDING.PAGES.SETTINGS_MENU.WHATS_NEW' }
  ),
  canned_list: page(
    'canned_list',
    'system',
    ['[data-testid="page-settings"]'],
    ['app/javascript/dashboard/routes/dashboard/settings/canned/**'],
    { version: 2, whatsNewKey: 'ONBOARDING.PAGES.CANNED_LIST.WHATS_NEW' }
  ),
  macros_wrapper: page(
    'macros_wrapper',
    'system',
    ['[data-testid="page-settings"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/macros/Index.vue',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacrosTableRow.vue',
    ],
    { version: 3, whatsNewKey: 'ONBOARDING.PAGES.MACROS_WRAPPER.WHATS_NEW' }
  ),
  macros_new: page(
    'macros_new',
    'system',
    [],
    [
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroEditor.vue',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroForm.vue',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroProperties.vue',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroNodes.vue',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroNode.vue',
    ],
    { version: 1, whatsNewKey: 'ONBOARDING.PAGES.MACROS_NEW.WHATS_NEW' }
  ),
  macros_edit: page(
    'macros_edit',
    'system',
    [],
    [
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroEditor.vue',
      'app/javascript/dashboard/store/modules/macros.js',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroForm.vue',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroProperties.vue',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroNodes.vue',
      'app/javascript/dashboard/routes/dashboard/settings/macros/MacroNode.vue',
    ],
    { version: 2, whatsNewKey: 'ONBOARDING.PAGES.MACROS_EDIT.WHATS_NEW' }
  ),
  labels_list: page(
    'labels_list',
    'system',
    ['[data-testid="page-settings"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/labels/**',
      'app/javascript/dashboard/components/widgets/ColorPicker.vue',
    ],
    { version: 3, whatsNewKey: 'ONBOARDING.PAGES.LABELS_LIST.WHATS_NEW' }
  ),
  attributes_list: page(
    'attributes_list',
    'system',
    ['[data-testid="page-settings"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/attributes/**',
      'app/javascript/dashboard/components-next/ConversationWorkflow/AttributeListItem.vue',
      'app/controllers/api/v1/accounts/custom_attribute_definitions_controller.rb',
      'app/javascript/dashboard/store/modules/attributes.js',
    ],
    { version: 3, whatsNewKey: 'ONBOARDING.PAGES.ATTRIBUTES_LIST.WHATS_NEW' }
  ),

  settings_teams_list: page(
    'settings_teams_list',
    'system',
    [],
    ['app/javascript/dashboard/routes/dashboard/settings/teams/Index.vue'],
    {
      version: 5,
      whatsNewKey: 'ONBOARDING.PAGES.SETTINGS_TEAMS_LIST.WHATS_NEW',
    }
  ),
  settings_teams_new: page(
    'settings_teams_new',
    'system',
    [],
    [
      'app/javascript/dashboard/routes/dashboard/settings/teams/TeamForm.vue',
      'app/javascript/dashboard/routes/dashboard/settings/teams/Create/CreateTeam.vue',
    ],
    { version: 3, whatsNewKey: 'ONBOARDING.PAGES.SETTINGS_TEAMS_NEW.WHATS_NEW' }
  ),
  settings_teams_edit: page(
    'settings_teams_edit',
    'system',
    [],
    [
      'app/javascript/dashboard/routes/dashboard/settings/teams/TeamForm.vue',
      'app/javascript/dashboard/routes/dashboard/settings/teams/Edit/EditTeam.vue',
    ],
    {
      // v4: editar time numa pagina so, com participantes.
      version: 4,
      whatsNewKey: 'ONBOARDING.PAGES.SETTINGS_TEAMS_EDIT.WHATS_NEW',
    }
  ),

  settings_teams_add_agents: page(
    'settings_teams_add_agents',
    'system',
    [],
    [
      'app/javascript/dashboard/routes/dashboard/settings/teams/AgentSelector.vue',
      'app/javascript/dashboard/routes/dashboard/settings/teams/Create/AddAgents.vue',
    ],
    {
      version: 3,
      whatsNewKey: 'ONBOARDING.PAGES.SETTINGS_TEAMS_ADD_AGENTS.WHATS_NEW',
    }
  ),
  // Desde a edicao em pagina unica, esta rota so redireciona para
  // settings_teams_edit (link salvo nao quebra); a tela de participantes da
  // edicao mora em Edit/EditTeam.vue, coberta pela entrada settings_teams_edit.
  settings_teams_edit_members: page(
    'settings_teams_edit_members',
    'system',
    [],
    [
      'app/javascript/dashboard/routes/dashboard/settings/teams/teams.routes.js',
    ],
    {
      version: 2,
      whatsNewKey: 'ONBOARDING.PAGES.SETTINGS_TEAMS_EDIT_MEMBERS.WHATS_NEW',
    }
  ),

  focus_hub: page(
    'focus_hub',
    'hub',
    ['[data-testid="hub-search"]'],
    [
      'app/javascript/dashboard/routes/dashboard/hub/**',
      'app/javascript/dashboard/components-next/workspaceV2/WorkspaceV2Shell.vue',
      'app/javascript/dashboard/components-next/workspaceV2/WorkspaceV2Hub.vue',
      'app/javascript/dashboard/components-next/workspaceV2/WorkspaceResizeControl.vue',
      'app/javascript/dashboard/components-next/sidebar/SidebarProfileMenu.vue',
      'app/javascript/dashboard/components-next/button/Button.vue',
      'app/javascript/dashboard/components-next/dialog/Dialog.vue',
      'app/javascript/dashboard/components-next/Editor/Editor.vue',
      'app/javascript/dashboard/components/widgets/WootWriter/Editor.vue',
      'app/javascript/dashboard/components/widgets/WootWriter/EditorLinkDialog.vue',
      'app/javascript/dashboard/helper/editorMenuAccessibility.js',
    ],
    // v40: o cartão da Central da IA mostra quantos itens esperam revisão.
    // v41: a Central da IA vai para o meio do Hub, com a constelação das áreas.
    // v42: as áreas da Central no Hub têm os nomes novos (Comentários,
    // Retomadas...) e abrem direto a área; Reports da IA só para administrador.
    // v39: a engrenagem abre todas as configurações; Configurar, as da área.
    // v37: Brasa identifica a Central da IA; atalhos respeitam os módulos da conta.
    // v33: Agenda no topo com Conversas/Kanban/Tarefas; busca sem
    // destino repetido (caixa de entrada).
    // v43: ícones da navegação em Solar duotone, com a peça que se mexe no
    // hover e no item ativo (identidade Visor); barra lateral de 264 px com
    // ícones de 24 px, contador em chip suave e escuro com contraste AA.
    { version: 43, whatsNewKey: 'ONBOARDING.PAGES.FOCUS_HUB.WHATS_NEW' }
  ),
  hub_world_home: page(
    'hub_world_home',
    'hub',
    ['[data-testid="hub-world-home"]'],
    [
      'app/javascript/dashboard/routes/dashboard/hub/HubWorldHome.vue',
      'app/javascript/dashboard/routes/dashboard/hub/useHubWorldStats.js',
      'app/javascript/dashboard/routes/dashboard/hub/AttendanceHome.vue',
      'app/javascript/dashboard/routes/dashboard/hub/useAttendanceHome.js',
      'app/javascript/dashboard/routes/dashboard/hub/hubDesign.css',
      'app/javascript/dashboard/routes/dashboard/hub/SalesHome.vue',
      'app/javascript/dashboard/routes/dashboard/hub/useSalesHome.js',
    ],
    // v2: versão "ação primeiro" (12/09): destaque com números vivos, chips
    // da fila, lista de campanhas e de fluxos, menos opções por área.
    // v3: Atender na versão aprovada na vistoria (fila num celular, gráfico
    // de 7 dias com os números em evidência, engrenagem na configuração).
    // v4: Vender como painel financeiro (indicadores em pilha, gráfico de 30
    // dias, o dia e o funil visto de cima).
    // v6: "vendas fechadas em 30 dias" do card de Vender conta pela data de
    // fechamento (won_at), nao pela data de criacao do cartao.
    {
      // v9: habilitação, atividade e alertas de execução aparecem separados.
      version: 9,
      whatsNewKey: 'ONBOARDING.PAGES.HUB_WORLD_HOME.WHATS_NEW',
    }
  ),
  help_guides: page(
    'help_guides',
    'system',
    ['[data-testid="page-onboarding-help"]'],
    ['app/javascript/dashboard/routes/dashboard/onboardingHelp/**']
  ),
  release_notes: page(
    'release_notes',
    'system',
    ['[data-testid="page-release-notes"]'],
    ['app/javascript/dashboard/routes/dashboard/releaseNotes/**']
  ),
  home: page(
    'home',
    'attendance',
    [
      '[data-testid="conversation-workbench-list-gutter"]',
      '[data-testid="focus-spot-header"]',
    ],
    [
      'app/javascript/dashboard/components-next/filter/SavedFilterLoadError.vue',
      'app/javascript/dashboard/components-next/filter/ConversationFilter.vue',
      'app/javascript/dashboard/routes/dashboard/customviews/DeleteCustomViews.vue',
      'app/javascript/dashboard/components/widgets/modal/DeleteModal.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/FolderConversationView.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/conversation.routes.js',
      'app/javascript/dashboard/store/modules/customViews.js',
      'app/javascript/dashboard/routes/dashboard/conversation/ConversationView.vue',
      'app/javascript/dashboard/components/ChatList.vue',
      'app/javascript/dashboard/components/ChatListHeader.vue',
      'app/javascript/dashboard/components-next/message/Message.vue',
      'app/javascript/dashboard/components/widgets/QuickFilterTabs.vue',
      'app/javascript/dashboard/components/widgets/conversation/ConversationCard.vue',
      'app/javascript/dashboard/components/ConversationSortSelector.vue',
    ],
    // v2: a ordenacao virou uma secao de 7 modos no menu Atalhos, persistida
    // por usuario (uiSettings.conversation_view_mode), no lugar do toggle de
    // dois estados.
    {
      version: 24,
      whatsNewKey: 'ONBOARDING.PAGES.HOME.WHATS_NEW',
    }
  ),
  // A conversa aberta e outra tela. A lista (home) cuida de abas, barra e
  // fixar; aqui e cabecalho, acoes, compositor e painel lateral. Separado em
  // 23/08 porque o tour da lista pedia o compositor sem conversa aberta.
  inbox_conversation: page(
    'inbox_conversation',
    'attendance',
    [
      '[data-testid="focus-spot-header"]',
      '[data-testid="conversation-composer"]',
    ],
    [
      'app/javascript/dashboard/components-next/filter/SavedFilterLoadError.vue',
      'app/javascript/dashboard/components-next/filter/ConversationFilter.vue',
      'app/javascript/dashboard/routes/dashboard/customviews/DeleteCustomViews.vue',
      'app/javascript/dashboard/components/widgets/modal/DeleteModal.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/FolderConversationView.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/conversation.routes.js',
      'app/javascript/dashboard/store/modules/customViews.js',
      'app/javascript/dashboard/components/widgets/conversation/**',
      'app/javascript/dashboard/components/widgets/QuickActionButtons.vue',
      'app/javascript/dashboard/components/widgets/WootWriter/**',
      'app/javascript/dashboard/components-next/Conversation/**',
      'app/javascript/dashboard/components-next/SidebarActionsHeader.vue',
      'app/javascript/dashboard/store/modules/conversations/**',
      'app/javascript/dashboard/components-next/message/**',
      'app/javascript/dashboard/routes/dashboard/internal-chat/components/KanbanMessageCards.vue',
      'app/javascript/dashboard/components-next/workspaceV2/WorkspaceContactToggle.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/ContactPanel.vue',
      'app/javascript/dashboard/components-next/workspaceV2/tasks/TaskCreateDialog.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/ConversationSidebar.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/ConversationAction.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/KanbanActions.vue',
      'app/javascript/dashboard/routes/dashboard/conversation/Macros/**',
    ],
    // v90: oportunidades da Central da IA em notas privadas interativas.
    // v91: nas caixas com sugestão no campo, a retomada aparece como cartão acima do campo.
    // v92: o cartão mostra o horário em que a retomada sai sozinha.
    // v93: a sugestão de imóveis usa o catálogo da própria conta e leva o nome dela.
    {
      version: 93,
      whatsNewKey: 'ONBOARDING.PAGES.INBOX_CONVERSATION.WHATS_NEW',
    }
  ),
  inbox_view: page(
    'inbox_view',
    'attendance',
    ['[data-testid="page-inbox-view"]'],
    ['app/javascript/dashboard/routes/dashboard/inbox/**'],
    // v885: a caixa ganhou filtros por categoria e tipo, e o sino do cluster.
    { version: 4, whatsNewKey: 'ONBOARDING.PAGES.INBOX_VIEW.WHATS_NEW' }
  ),
  notifications_index: page(
    'notifications_index',
    'attendance',
    ['[data-testid="page-notifications"]'],
    ['app/javascript/dashboard/routes/dashboard/notifications/**'],
    {
      version: 4,
      whatsNewKey: 'ONBOARDING.PAGES.NOTIFICATIONS_INDEX.WHATS_NEW',
    }
  ),
  internal_chat: page(
    'internal_chat',
    'attendance',
    ['[data-testid="page-internal-chat"]'],
    [
      'app/javascript/dashboard/routes/dashboard/internal-chat/**',
      'app/javascript/dashboard/composables/useInternalChatContinuity.js',
      'app/javascript/dashboard/components-next/message/chips/Audio.vue',
    ],
    { version: 53, whatsNewKey: 'ONBOARDING.PAGES.INTERNAL_CHAT.WHATS_NEW' }
  ),
  voip_calls: page(
    'voip_calls',
    'attendance',
    ['[data-testid="page-voip-calls"]'],
    [
      'app/javascript/dashboard/routes/dashboard/voipCalls/**',
      'app/javascript/dashboard/components-next/message/chips/Audio.vue',
      'app/javascript/dashboard/store/modules/voipDisposition.js',
      'app/controllers/api/v1/accounts/call_records_controller.rb',
      'app/services/voip/disposition_save_service.rb',
      'app/controllers/api/v1/accounts/voip_pending_dispositions_controller.rb',
    ],
    { version: 51, whatsNewKey: 'ONBOARDING.PAGES.VOIP_CALLS.WHATS_NEW' }
  ),
  kanban_board: page(
    'kanban_board',
    'sales',
    ['[data-testid="page-kanban"]'],
    ['app/javascript/dashboard/routes/dashboard/kanban/**'],
    // v2: o popup de confirmação de agendamento (WAHA) foi redesenhado.
    // v3: tarefas do card usam o editor completo e preservam contexto V1/V2.
    // v51: barra única com o funil como primeiro controle e botões com nome;
    // filtros de responsável, caixa de entrada e ganhos/perdidos entraram em
    // "Filtros"; card mostra o título inteiro, o status uma vez só e a prévia
    // limpa, com o próximo passo (tarefa ou compromisso) em destaque, vermelho
    // quando atrasado; clicar no card abre um painel ao lado com a conversa
    // para leitura e atalho para a caixa de entrada, sem sair do quadro;
    // voltar do navegador fecha o painel; o sistema lembra o último funil
    // aberto; "Exibição do card" deixa cada pessoa escolher o que aparece.
    // v52: marcar cartões faz aparecer uma barra com as ações em massa, e a
    // configuração do quadro virou a página Configurar, aberta pela
    // engrenagem ao lado do funil. O menu de três pontos e o raio da coluna
    // saíram; "Dashboard" virou "Números".
    // v53: Compartilhar do cartão virou menu: copiar link, enviar no chat
    // interno para um colega ou sala, e gerenciar acesso.
    // v54: o disparo saiu do quadro. O botão do avião e o painel "Disparar
    // mensagem" foram removidos; na barra de seleção ficou "Criar campanha",
    // que abre a campanha nova com o público = cartões marcados.
    {
      views: ['kanban'],
      // v55: link com ?funnel= abre o funil certo.
      // v59: Configurar > IA do funil mostra primeiro o padrão da conta e,
      // no funil, a escolha entre usar o padrão ou ter regra própria.
      // v60: o cartão do padrão da conta resume a regra em linguagem simples.
      // v61: busca mostra o total real e a ação em massa pode valer para a etapa inteira.
      version: 61,
      whatsNewKey: 'ONBOARDING.PAGES.KANBAN_BOARD.WHATS_NEW',
    }
  ),
  kanban_board__agenda: page(
    'kanban_board__agenda',
    'sales',
    ['[data-testid="page-agenda"]', '[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/agenda/**',
      'app/javascript/dashboard/routes/dashboard/kanban/components/AgendaTab.vue',
    ],
    // v27: agenda com cabeçalho próprio; equipe num seletor com busca; faixa
    // "Tarefas" no topo de cada dia nas vistas Dia e Semana, atrasada em
    // vermelho, com liga e desliga; compromissos legíveis na vista Mês com
    // cor por responsável.
    // v28: agendamento único (mesmo formulário em Agenda, cartão, conversa e
    // Central), compromisso espelhado no cartão e conferência antes de avisar
    // o cliente no WhatsApp.
    // v30: padrão da conta e modo de sincronização do Google por funil na
    // própria Agenda, com salvamento explícito.
    {
      routeName: 'kanban_board',
      view: 'agenda',
      version: 30,
      whatsNewKey: 'ONBOARDING.PAGES.KANBAN_BOARD__AGENDA.WHATS_NEW',
    }
  ),
  kanban_board__dashboard: page(
    'kanban_board__dashboard',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/KanbanDashboard.vue',
    ],
    { routeName: 'kanban_board', view: 'dashboard' }
  ),
  kanban_board__list: page(
    'kanban_board__list',
    'sales',
    ['[data-testid="page-kanban"]'],
    ['app/javascript/dashboard/routes/dashboard/kanban/components/ListTab.vue'],
    // v3: valor zerado não aparece mais em cada linha e a prévia da conversa
    // vem limpa.
    {
      routeName: 'kanban_board',
      view: 'list',
      version: 3,
      whatsNewKey: 'ONBOARDING.PAGES.KANBAN_BOARD__LIST.WHATS_NEW',
    }
  ),
  kanban_board__map: page(
    'kanban_board__map',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/KanbanMap.vue',
    ],
    // v898: a tela passou a falar o idioma da conta (o texto era portugues
    // cravado) e os dois botoes da barra lateral sairam da cor fixa, que era
    // ilegivel no tema escuro.
    {
      routeName: 'kanban_board',
      view: 'map',
      // v3: mostra quantos cards com endereço existem e carrega mais de 100 em 100.
      version: 3,
      whatsNewKey: 'ONBOARDING.PAGES.KANBAN_BOARD__MAP.WHATS_NEW',
    }
  ),
  kanban_board__offers: page(
    'kanban_board__offers',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/OffersManager.vue',
      'app/javascript/dashboard/routes/dashboard/kanban/components/OffersHeader.vue',
    ],
    // v2: a lista de ofertas passou a ser paginada (15 por pagina) e o aviso
    // falso de "limite de 10 ofertas", que nao bloqueava nada e nao tinha
    // saida, foi removido.
    {
      routeName: 'kanban_board',
      view: 'offers',
      version: 2,
      whatsNewKey: 'ONBOARDING.PAGES.KANBAN_BOARD__OFFERS.WHATS_NEW',
    }
  ),
  kanban_board__offer_packages: page(
    'kanban_board__offer_packages',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/OfferPackagesManager.vue',
    ],
    { routeName: 'kanban_board', view: 'offer_packages' }
  ),
  kanban_board__quick_actions: page(
    'kanban_board__quick_actions',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/QuickActionsManager.vue',
    ],
    { routeName: 'kanban_board', view: 'quick-actions' }
  ),
  kanban_board__templates: page(
    'kanban_board__templates',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/MessageTemplates.vue',
      'app/javascript/dashboard/routes/dashboard/kanban/components/MessageTemplatesHeader.vue',
      'app/javascript/dashboard/routes/dashboard/kanban/components/MessageTemplateForm.vue',
    ],
    { routeName: 'kanban_board', view: 'templates' }
  ),
  kanban_board__scheduled_messages: page(
    'kanban_board__scheduled_messages',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/ScheduledMessagesTab.vue',
    ],
    { routeName: 'kanban_board', view: 'scheduled_messages' }
  ),
  kanban_board__funnels: page(
    'kanban_board__funnels',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/FunnelsManager.vue',
      'app/javascript/dashboard/routes/dashboard/kanban/components/FunnelsHeader.vue',
      'app/javascript/dashboard/routes/dashboard/kanban/components/FunnelForm.vue',
      'app/javascript/dashboard/routes/dashboard/kanban/components/FunnelGoogleCalendarSection.vue',
      'app/javascript/dashboard/routes/dashboard/kanban/components/FunnelsGlobalAiSettings.vue',
      'app/javascript/dashboard/routes/dashboard/kanban/components/FunnelAiRuleSource.vue',
    ],
    {
      routeName: 'kanban_board',
      view: 'funnels',
      // v6: a IA do funil escolhe entre o padrão da conta (mostrado só para
      // leitura, com o aviso quando a conta não cobre o funil) e regra própria.
      // v7: IA global numa tela só, com prévia do cartão e ajustes avançados.
      version: 7,
      whatsNewKey: 'ONBOARDING.PAGES.KANBAN_BOARD__FUNNELS.WHATS_NEW',
    }
  ),
  kanban_board__stage_automations: page(
    'kanban_board__stage_automations',
    'sales',
    ['[data-testid="page-kanban"]'],
    [
      'app/javascript/dashboard/routes/dashboard/kanban/components/KanbanStageAutomationsView.vue',
    ],
    {
      routeName: 'kanban_board',
      view: 'stage_automations',
      version: 2,
      whatsNewKey: 'ONBOARDING.PAGES.KANBAN_BOARD__STAGE_AUTOMATIONS.WHATS_NEW',
    }
  ),
  tasks: page(
    'tasks',
    'sales',
    ['[data-testid="page-tasks"]'],
    [
      'app/javascript/dashboard/routes/dashboard/tasks/**',
      'app/javascript/dashboard/components-next/workspaceV2/tasks/**',
      'app/javascript/dashboard/helper/taskViewRequest.js',
      'app/javascript/dashboard/helper/taskTemplateRequest.js',
      'app/javascript/dashboard/helper/taskViewDraft.js',
    ],
    // v81: somente autor e gestor encerram ou apagam registro de tempo.
    // v82: cabeçalho mais limpo com "Filtros" num botão só e o restante no
    // menu de três pontos; lista agrupada por vencimento com atrasadas no
    // topo e concluídas recolhidas no fim; clicar na tarefa abre um painel ao
    // lado com o card ligado, a conversa e as subtarefas; ações da tarefa no
    // menu de três pontos; quadro visível no tema escuro.
    // v83: linha rápida no topo da lista (texto, dia, responsável, Enter) e um
    // formulário único de nova tarefa em todos os pontos de entrada, com
    // subtarefas já na criação.
    { version: 84, whatsNewKey: 'ONBOARDING.PAGES.TASKS.WHATS_NEW' }
  ),
  contacts_dashboard_index: page(
    'contacts_dashboard_index',
    'sales',
    ['[data-testid="page-contacts"]'],
    [
      'app/javascript/dashboard/components-next/filter/SavedFilterLoadError.vue',
      'app/javascript/dashboard/store/modules/customViews.js',
      'app/javascript/dashboard/routes/dashboard/contacts/**',
      'app/javascript/dashboard/components-next/Contacts/**',
    ],
    // v2: a lista deixou de cortar no celular. Nome e e-mail agora truncam
    // com reticencias dentro do card, o titulo e a busca ganharam linha
    // propria e a paginacao subiu para cima da barra inferior.
    {
      version: 66,
      whatsNewKey: 'ONBOARDING.PAGES.CONTACTS_DASHBOARD_INDEX.WHATS_NEW',
    }
  ),
  contacts_waha_duplicates: page(
    'contacts_waha_duplicates',
    'sales',
    ['[data-testid="waha-duplicates-review"]'],
    ['app/javascript/dashboard/components-next/Contacts/WahaDuplicates/**'],
    {
      version: 1,
      whatsNewKey: 'ONBOARDING.PAGES.CONTACTS_WAHA_DUPLICATES.WHATS_NEW',
    }
  ),
  contacts_edit: page(
    'contacts_edit',
    'sales',
    ['[data-testid="page-contact-detail"]'],
    [
      'app/javascript/dashboard/routes/dashboard/contacts/pages/ContactManageView.vue',
      'app/javascript/dashboard/components-next/Contacts/**',
      'app/javascript/dashboard/components-next/SharedAttachments/**',
      'app/javascript/dashboard/components-next/Conversation/ConversationCard/**',
    ],
    { version: 32, whatsNewKey: 'ONBOARDING.PAGES.CONTACTS_EDIT.WHATS_NEW' }
  ),
  companies_dashboard_index: page(
    'companies_dashboard_index',
    'sales',
    ['[data-testid="page-companies"]'],
    [
      'app/javascript/dashboard/routes/dashboard/companies/**',
      'app/javascript/dashboard/components-next/Companies/**',
    ],
    {
      version: 13,
      whatsNewKey: 'ONBOARDING.PAGES.COMPANIES_DASHBOARD_INDEX.WHATS_NEW',
    }
  ),
  companies_dashboard_show: page(
    'companies_dashboard_show',
    'sales',
    ['[data-testid="page-company-detail"]'],
    [
      'app/javascript/dashboard/routes/dashboard/companies/pages/CompanyDetailView.vue',
      'app/javascript/dashboard/components-next/Companies/CompaniesDetailsLayout.vue',
      'app/javascript/dashboard/components-next/Companies/CompanyDetail/**',
      'app/javascript/dashboard/components-next/Conversation/ConversationCard/**',
    ],
    {
      version: 11,
      whatsNewKey: 'ONBOARDING.PAGES.COMPANIES_DASHBOARD_SHOW.WHATS_NEW',
    }
  ),
  campaigns_livechat_index: page(
    'campaigns_livechat_index',
    'marketing',
    ['[data-testid="page-campaigns"]'],
    [
      'app/javascript/dashboard/routes/dashboard/campaigns/pages/LiveChatCampaignsPage.vue',
      'app/javascript/dashboard/components-next/Campaigns/Pages/CampaignPage/LiveChatCampaign/**',
      'app/javascript/dashboard/components-next/Campaigns/CampaignCard/**',
      'app/javascript/dashboard/routes/dashboard/campaigns/pages/CampaignsPageRouteView.vue',
      'app/javascript/dashboard/store/modules/campaigns.js',
    ],
    {
      version: 8,
      whatsNewKey: 'ONBOARDING.PAGES.CAMPAIGNS_LIVECHAT_INDEX.WHATS_NEW',
    }
  ),
  campaigns_sms_index: page(
    'campaigns_sms_index',
    'marketing',
    ['[data-testid="page-campaigns"]'],
    [
      'app/javascript/dashboard/routes/dashboard/campaigns/pages/SMSCampaignsPage.vue',
      'app/javascript/dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppCampaign/**',
      'app/javascript/dashboard/components-next/Campaigns/CampaignCard/**',
      'app/javascript/dashboard/routes/dashboard/campaigns/pages/CampaignsPageRouteView.vue',
      'app/javascript/dashboard/store/modules/campaigns.js',
    ],
    {
      version: 7,
      whatsNewKey: 'ONBOARDING.PAGES.CAMPAIGNS_SMS_INDEX.WHATS_NEW',
    }
  ),
  campaigns_whatsapp_index: page(
    'campaigns_whatsapp_index',
    'marketing',
    ['[data-testid="page-campaigns"]'],
    [
      'app/javascript/dashboard/routes/dashboard/campaigns/pages/WhatsAppCampaignsPage.vue',
      'app/javascript/dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppCampaign/**',
      'app/javascript/dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignForm/**',
      'app/javascript/dashboard/components-next/Campaigns/CampaignCard/**',
      'app/javascript/dashboard/routes/dashboard/campaigns/pages/CampaignsPageRouteView.vue',
      'app/javascript/dashboard/store/modules/campaigns.js',
    ],
    {
      // v12: formulario unico de campanha em blocos numerados (decisao 28).
      // v13: previa do publico conta cartao sem contato.
      version: 13,
      whatsNewKey: 'ONBOARDING.PAGES.CAMPAIGNS_WHATSAPP_INDEX.WHATS_NEW',
    }
  ),
  campaigns_scheduled_index: page(
    'campaigns_scheduled_index',
    'marketing',
    ['[data-testid="page-campaigns"]'],
    [
      'app/javascript/dashboard/routes/dashboard/campaigns/pages/ScheduledCampaignsPage.vue',
      'app/javascript/dashboard/routes/dashboard/campaigns/pages/CampaignsPageRouteView.vue',
      'app/javascript/dashboard/store/modules/campaigns.js',
    ],
    {
      version: 4,
      whatsNewKey: 'ONBOARDING.PAGES.CAMPAIGNS_SCHEDULED_INDEX.WHATS_NEW',
    }
  ),
  email_sequence_editor: page(
    'email_sequence_editor',
    'marketing',
    ['[data-testid="page-email-sequence-editor"]'],
    [
      'app/javascript/dashboard/routes/dashboard/emailSequences/EmailSequenceFlowEditor.vue',
      'app/javascript/dashboard/routes/dashboard/emailSequences/components/**',
      'app/javascript/dashboard/components/widgets/EmailEditor.vue',
    ],
    {
      version: 5,
      whatsNewKey: 'ONBOARDING.PAGES.EMAIL_SEQUENCE_EDITOR.WHATS_NEW',
    }
  ),
  email_sequences: page(
    'email_sequences',
    'marketing',
    ['[data-testid="page-email-sequences"]'],
    ['app/javascript/dashboard/routes/dashboard/emailSequences/**'],
    { version: 49, whatsNewKey: 'ONBOARDING.PAGES.EMAIL_SEQUENCES.WHATS_NEW' }
  ),
  whatsapp_groups_campaigns: page(
    'whatsapp_groups_campaigns',
    'marketing',
    ['[data-testid="page-whatsapp-groups"]'],
    ['app/javascript/dashboard/routes/dashboard/whatsappGroups/**'],
    // 26/09/2026: tipo GIF no disparo (.gif ou .mp4 chegam animados).
    {
      version: 16,
      whatsNewKey: 'ONBOARDING.PAGES.WHATSAPP_GROUPS_CAMPAIGNS.WHATS_NEW',
    }
  ),
  instagram_automation_index: page(
    'instagram_automation_index',
    'marketing',
    ['[data-testid="page-instagram-automation"]'],
    ['app/javascript/dashboard/routes/dashboard/instagramAutomation/**'],
    {
      version: 2,
      whatsNewKey: 'ONBOARDING.PAGES.INSTAGRAM_AUTOMATION_INDEX.WHATS_NEW',
    }
  ),
  facebook_automation_index: page(
    'facebook_automation_index',
    'marketing',
    ['[data-testid="page-facebook-automation"]'],
    ['app/javascript/dashboard/routes/dashboard/facebookAutomation/**']
  ),
  captain_assistants_index: page(
    'captain_assistants_index',
    'automation',
    ['[data-testid="page-captain"]'],
    [
      'app/javascript/dashboard/routes/dashboard/captain/**',
      'app/javascript/dashboard/store/captain/response.js',
      'app/javascript/dashboard/store/captain/bulkActions.js',
      'app/javascript/dashboard/composables/useCaptainOperationContext.js',
      'app/javascript/dashboard/components-next/captain/pageComponents/BulkDeleteDialog.vue',
      'app/javascript/dashboard/components-next/captain/assistant/DocumentBulkActions.vue',
      'app/javascript/dashboard/components-next/captain/assistant/ResponseCard.vue',
      'app/javascript/dashboard/components-next/captain/pageComponents/response/ResponseForm.vue',
      'app/javascript/dashboard/components-next/captain/pageComponents/response/CreateResponseDialog.vue',
      'app/javascript/dashboard/components-next/captain/pageComponents/document/DocumentForm.vue',
      'app/javascript/dashboard/components-next/captain/pageComponents/document/CreateDocumentDialog.vue',
      'app/javascript/dashboard/components-next/captain/PageLayout.vue',
      'app/javascript/dashboard/components-next/captain/pageComponents/switcher/AssistantSwitcher.vue',
      'app/javascript/dashboard/components-next/captain/pageComponents/assistant/AssistantForm.vue',
      'app/javascript/dashboard/components-next/captain/pageComponents/assistant/CreateAssistantDialog.vue',
    ],
    // v2 (02/09/2026): configurações do assistente em 5 abas guiadas.
    {
      version: 16,
      whatsNewKey: 'ONBOARDING.PAGES.CAPTAIN_ASSISTANTS_INDEX.WHATS_NEW',
    }
  ),
  ai_agents_provider: page(
    'ai_agents_provider',
    'automation',
    ['[data-testid="page-ai-agents"]'],
    ['app/javascript/dashboard/routes/dashboard/settings/aiAgents/**']
  ),
  conversation_workflows_index: page(
    'conversation_workflows_index',
    'automation',
    ['[data-testid="page-conversation-workflows"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/conversationWorkflows/**',
    ],
    {
      version: 7,
      whatsNewKey: 'ONBOARDING.PAGES.CONVERSATION_WORKFLOWS_INDEX.WHATS_NEW',
    }
  ),
  auditlogs_list: page(
    'auditlogs_list',
    'system',
    ['[data-testid="page-auditlogs"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/auditlogs/**',
      'app/javascript/dashboard/store/modules/auditlogs.js',
    ]
  ),
  conversation_workflows_edit: page(
    'conversation_workflows_edit',
    'automation',
    ['[data-testid="page-conversation-workflow-editor"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/conversationWorkflows/FlowEditor.vue',
    ],
    // v4 (27/09/2026): botões dentro do balão no Instagram e Primeiro nome.
    {
      version: 4,
      whatsNewKey: 'ONBOARDING.PAGES.CONVERSATION_WORKFLOWS_EDIT.WHATS_NEW',
    }
  ),
  conversation_workflows_execution_detail: page(
    'conversation_workflows_execution_detail',
    'automation',
    ['[data-testid="page-conversation-workflow-execution-detail"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/conversationWorkflows/FlowExecutionDetail.vue',
    ],
    {
      version: 5,
      whatsNewKey:
        'ONBOARDING.PAGES.CONVERSATION_WORKFLOWS_EXECUTION_DETAIL.WHATS_NEW',
    }
  ),
  conversation_workflows_executions: page(
    'conversation_workflows_executions',
    'automation',
    ['[data-testid="page-conversation-workflow-history"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/conversationWorkflows/FlowExecutionsHistory.vue',
    ],
    {
      // v4: histórico paginado, com as execuções antigas acessíveis.
      version: 4,
      whatsNewKey:
        'ONBOARDING.PAGES.CONVERSATION_WORKFLOWS_EXECUTIONS.WHATS_NEW',
    }
  ),
  automation_list: page(
    'automation_list',
    'automation',
    ['[data-testid="page-automation-rules"]'],
    ['app/javascript/dashboard/routes/dashboard/settings/automation/**'],
    { version: 2, whatsNewKey: 'ONBOARDING.PAGES.AUTOMATION_LIST.WHATS_NEW' }
  ),
  automation_logs: page(
    'automation_logs',
    'automation',
    ['[data-testid="page-automation-logs"]'],
    ['app/javascript/dashboard/routes/dashboard/automationLogs/**'],
    { version: 2, whatsNewKey: 'ONBOARDING.PAGES.AUTOMATION_LOGS.WHATS_NEW' }
  ),
  account_overview_reports: page(
    'account_overview_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/LiveReports.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/overview/**',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/heatmaps/**',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/OverviewReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v4: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 4,
      whatsNewKey: 'ONBOARDING.PAGES.ACCOUNT_OVERVIEW_REPORTS.WHATS_NEW',
    }
  ),
  conversation_reports: page(
    'conversation_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/Index.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/ReportContainer.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v3: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 3,
      whatsNewKey: 'ONBOARDING.PAGES.CONVERSATION_REPORTS.WHATS_NEW',
    }
  ),
  csat_reports: page(
    'csat_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/CsatResponses.vue',
      'app/javascript/dashboard/components/table/Pagination.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/Csat/**',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/CsatTable.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/CsatExpandedRow.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v14: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 14,
      whatsNewKey: 'ONBOARDING.PAGES.CSAT_REPORTS.WHATS_NEW',
    }
  ),
  sla_reports: page(
    'sla_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/SLAReports.vue',
      'enterprise/app/models/applied_sla.rb',
      'app/javascript/dashboard/components/widgets/conversation/components/SLAPopoverCard.vue',
      'app/javascript/dashboard/components/widgets/conversation/components/SLAEventItem.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/SLA/**',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v16: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 16,
      whatsNewKey: 'ONBOARDING.PAGES.SLA_REPORTS.WHATS_NEW',
    }
  ),
  bot_reports: page(
    'bot_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/BotReports.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/BotMetrics.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v3: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 3,
      whatsNewKey: 'ONBOARDING.PAGES.BOT_REPORTS.WHATS_NEW',
    }
  ),
  kanban_reports: page(
    'kanban_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/KanbanReports.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/KanbanMetrics.vue',
    ],
    // v3: dois blocos separados (Fechados no periodo por data de fechamento,
    // Criados no periodo por data de criacao); BODY antigo dizia que o periodo
    // so filtrava por criacao, o que deixou de ser verdade.
    { version: 3, whatsNewKey: 'ONBOARDING.PAGES.KANBAN_REPORTS.WHATS_NEW' }
  ),
  agent_reports_index: page(
    'agent_reports_index',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/AgentReportsIndex.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/AgentReportsShow.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/OverviewReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v3: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 3,
      whatsNewKey: 'ONBOARDING.PAGES.AGENT_REPORTS_INDEX.WHATS_NEW',
    }
  ),
  label_reports_index: page(
    'label_reports_index',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/LabelReportsIndex.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/LabelReportsShow.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/OverviewReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v3: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 3,
      whatsNewKey: 'ONBOARDING.PAGES.LABEL_REPORTS_INDEX.WHATS_NEW',
    }
  ),
  inbox_reports_index: page(
    'inbox_reports_index',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/InboxReportsIndex.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/InboxReportsShow.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/OverviewReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v4: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 4,
      whatsNewKey: 'ONBOARDING.PAGES.INBOX_REPORTS_INDEX.WHATS_NEW',
    }
  ),
  team_reports_index: page(
    'team_reports_index',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/TeamReportsIndex.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/TeamReportsShow.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/OverviewReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilters.vue',
      'app/javascript/dashboard/routes/dashboard/settings/reports/components/ReportFilterPanel.vue',
    ],
    {
      // v4: fuso da conta em todos os horarios e a tela agora vive na casa
      // unica de Relatorios, em aba.
      version: 4,
      whatsNewKey: 'ONBOARDING.PAGES.TEAM_REPORTS_INDEX.WHATS_NEW',
    }
  ),
  integration_events_report: page(
    'integration_events_report',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/IntegrationEventsReport.vue',
      'app/controllers/api/v1/accounts/integration_events_controller.rb',
    ],
    {
      version: 5,
      whatsNewKey: 'ONBOARDING.PAGES.INTEGRATION_EVENTS_REPORT.WHATS_NEW',
    }
  ),
  campaign_reports: page(
    'campaign_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/CampaignReports.vue',
      'app/javascript/dashboard/routes/dashboard/settings/inbox/WhatsappReports.vue',
    ]
  ),
  ai_reports: page(
    'ai_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/AiReports.vue',
      'app/javascript/dashboard/routes/dashboard/captain/assistants/ai_panel/Index.vue',
    ]
  ),
  voip_reports: page(
    'voip_reports',
    'analytics',
    ['[data-testid="page-reports"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/reports/VoipReports.vue',
      'app/javascript/dashboard/routes/dashboard/voipCalls/VoipAnalytics.vue',
    ]
  ),
  help_center_index: page(
    'help_center_index',
    'system',
    ['[data-testid="page-help-center"]'],
    ['app/javascript/dashboard/routes/dashboard/helpcenter/**'],
    {
      version: 2,
      whatsNewKey: 'ONBOARDING.PAGES.HELP_CENTER_INDEX.WHATS_NEW',
    }
  ),
  general_settings_index: page(
    'general_settings_index',
    'system',
    ['[data-testid="page-settings"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/account/**',
      'app/javascript/dashboard/routes/dashboard/settings/SettingsNav.vue',
      'app/javascript/dashboard/routes/dashboard/settings/SettingsWrapper.vue',
    ],
    {
      // v5: campo "Fuso horario dos relatorios".
      // v8: um voltar só, que diz o destino e volta para a tela de origem.
      // v9: módulos por área, aviso de fuso padrão e rodapé só com a versão.
      version: 9,
      whatsNewKey: 'ONBOARDING.PAGES.GENERAL_SETTINGS_INDEX.WHATS_NEW',
    }
  ),
  agent_list: page(
    'agent_list',
    'system',
    ['[data-testid="page-settings"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/agents/Index.vue',
      'app/javascript/dashboard/routes/dashboard/settings/components/BaseSettingsHeader.vue',
      'app/javascript/dashboard/components/widgets/BackButton.vue',
    ],
    {
      // v7: o voltar interno saiu; o da barra diz o destino.
      // v8: assentos em uso e papel separado do perfil de acesso.
      version: 8,
      whatsNewKey: 'ONBOARDING.PAGES.AGENT_LIST.WHATS_NEW',
    }
  ),
  lead_scoring_settings: page(
    'lead_scoring_settings',
    'system',
    ['[data-testid="page-lead-scoring"]'],
    ['app/javascript/dashboard/routes/dashboard/settings/leadScoring/**'],
    {
      version: 9,
      whatsNewKey: 'ONBOARDING.PAGES.LEAD_SCORING_SETTINGS.WHATS_NEW',
    }
  ),
  settings_inbox_list: page(
    'settings_inbox_list',
    'system',
    [],
    ['app/javascript/dashboard/routes/dashboard/settings/inbox/**'],
    {
      version: 4,
      whatsNewKey: 'ONBOARDING.PAGES.SETTINGS_INBOX_LIST.WHATS_NEW',
    }
  ),
  settings_integrations_lead_capture: page(
    'settings_integrations_lead_capture',
    'system',
    [],
    ['app/javascript/dashboard/routes/dashboard/settings/leadCapture/**'],
    {
      version: 1,
      whatsNewKey:
        'ONBOARDING.PAGES.SETTINGS_INTEGRATIONS_LEAD_CAPTURE.WHATS_NEW',
    }
  ),
  settings_integrations_purchases: page(
    'settings_integrations_purchases',
    'system',
    ['[data-testid="page-purchase-integrations"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/integrations/PurchaseIntegrations.vue',
    ]
  ),
  settings_applications_integration: page(
    'settings_applications_integration',
    'system',
    ['[data-testid="integration-hooks"]'],
    [
      'app/javascript/dashboard/routes/dashboard/settings/integrations/IntegrationHooks.vue',
    ],
    {
      version: 4,
      whatsNewKey:
        'ONBOARDING.PAGES.SETTINGS_APPLICATIONS_INTEGRATION.WHATS_NEW',
    }
  ),
  settings_applications: page(
    'settings_applications',
    'system',
    ['[data-testid="page-integrations"]'],
    ['app/javascript/dashboard/routes/dashboard/settings/integrations/**'],
    {
      version: 9,
      whatsNewKey: 'ONBOARDING.PAGES.SETTINGS_APPLICATIONS.WHATS_NEW',
    }
  ),
});

export const ALL_COACH_ROUTES = Object.freeze(Object.keys(PAGE_COACH));

// Rotas irmas: variacoes de URL que renderizam a MESMA tela. O Hub aponta so
// para a rota base, mas o atendente chega nas outras o tempo todo (abrir uma
// conversa muda de `home` para `inbox_conversation`, filtrar por rotulo muda
// para `label_conversations`, e por ai vai). Sem este mapa a dica nunca
// aparecia para quem entrou pela variacao, que foi o que o Lucas viu em
// staging em 23/08.
export const ROUTE_ALIASES = Object.freeze({
  // Toda rota de lista resolve para home; conversa aberta (rota com
  // conversation_id) resolve para inbox_conversation.
  inbox_dashboard: 'home',
  conversation_through_inbox: 'inbox_conversation',
  label_conversations: 'home',
  conversations_through_label: 'inbox_conversation',
  team_conversations: 'home',
  conversations_through_team: 'inbox_conversation',
  folder_conversations: 'home',
  conversations_through_folders: 'inbox_conversation',
  conversation_mentions: 'home',
  conversation_through_mentions: 'inbox_conversation',
  conversation_unattended: 'home',
  conversation_through_unattended: 'inbox_conversation',
  conversation_unread: 'home',
  conversation_through_unread: 'inbox_conversation',
  conversation_participating: 'home',
  conversation_through_participating: 'inbox_conversation',
  inbox_view_conversation: 'inbox_view',
  voip_leads: 'voip_calls',
  voip_leads_focus: 'voip_calls',
  voip_lead_detail: 'voip_calls',
  voip_calls_review: 'voip_calls',
  voip_analytics: 'voip_calls',
  captain_assistants_responses_index: 'captain_assistants_index',
  captain_assistants_documents_index: 'captain_assistants_index',
  captain_assistants_playground_index: 'captain_assistants_index',
  captain_assistants_inboxes_index: 'captain_assistants_index',
  captain_assistants_schedules_index: 'captain_assistants_index',
  captain_assistants_settings_index: 'captain_assistants_index',
  // Central da IA com rota própria por área, item, campanha e Ajustes
  // (redesign de 24/09): todas mostram a mesma dica da Central.
  ai_center_area: 'ai_center',
  ai_center_item: 'ai_center',
  ai_center_campaign: 'ai_center',
  ai_settings: 'ai_center',
});

// Sub-view: a mesma rota com `?view=` e outra tela (Kanban vs Agenda vs
// Ofertas). A chave da sub-view e `rota__view` (hifen vira underscore) e a
// entrada base so vale para as views listadas em `views` (ou sem view).
// Sub-view sem entrada propria NAO herda a da rota: antes disso a Agenda
// abria o tour do Kanban (reportado pelo Lucas em 23/08).
export const subViewKey = (routeName, view) =>
  `${routeName}__${String(view).replace(/-/g, '_')}`;

export const coachForRoute = (routeName, view = null) => {
  if (!routeName) return null;
  const canonica = ROUTE_ALIASES[routeName] || routeName;
  const currentView = typeof view === 'string' && view ? view : null;
  if (currentView) {
    const own = PAGE_COACH[subViewKey(canonica, currentView)];
    if (own) return own;
    const base = PAGE_COACH[canonica];
    if (base && Array.isArray(base.views) && base.views.includes(currentView)) {
      return base;
    }
    return null;
  }
  return PAGE_COACH[canonica] || null;
};

// `view` de uma rota do vue-router (query.view pode vir como array).
export const routeViewOf = route => {
  const raw = route?.query?.view;
  const value = Array.isArray(raw) ? raw[0] : raw;
  return typeof value === 'string' && value ? value : null;
};

// true legado conta como versão 1 (o usuário já viu a dica original).
export const seenVersionOf = value => {
  if (value === true) return 1;
  const numeric = Number(value);
  if (Number.isFinite(numeric) && numeric > 0) return numeric;
  return null;
};

export const coachMode = (entry, seenVersion) => {
  if (!entry) return null;
  const seen = seenVersionOf(seenVersion);
  if (seen == null) return 'first';
  if (seen < Number(entry.version)) return 'whats-new';
  return null;
};

// Icones Remix literais: o JIT so emite CSS de classe escrita por extenso.
export const DEFAULT_SECTION_ICON = 'i-ri-bookmark-line';
export const DEFAULT_SCREEN_ICON = 'i-ri-book-open-line';
export const HUB_SCREEN_ICON = 'i-ri-apps-line';

export const SECTION_ICONS = Object.freeze({
  'Screen areas': 'i-ri-layout-line',
  'Áreas da tela': 'i-ri-layout-line',
  'Sidebars and width': 'i-ri-sidebar-fold-line',
  'Barras laterais e largura': 'i-ri-sidebar-fold-line',
  'Board and views': 'i-ri-layout-grid-line',
  'Quadro e visões': 'i-ri-layout-grid-line',
  'Pin, shortcuts, composer': 'i-ri-keyboard-line',
  'Fixar, atalhos e compositor': 'i-ri-keyboard-line',
  'Not obvious': 'i-ri-lightbulb-line',
  'Não é óbvio': 'i-ri-lightbulb-line',
  'Create and bulk': 'i-ri-stack-line',
  'Criar e em lote': 'i-ri-stack-line',
  'List and bulk': 'i-ri-stack-line',
  'Lista e lote': 'i-ri-stack-line',
  'Bulk actions': 'i-ri-stack-line',
  'Ações em lote': 'i-ri-stack-line',
  Filters: 'i-ri-filter-3-line',
  Filtros: 'i-ri-filter-3-line',
  'Filters and views': 'i-ri-filter-3-line',
  'Filtros e visões': 'i-ri-filter-3-line',
  'Filters and capacity': 'i-ri-filter-3-line',
  'Filtros e capacidade': 'i-ri-filter-3-line',
  'How to open and filter': 'i-ri-filter-3-line',
  'Abrir e filtrar': 'i-ri-filter-3-line',
  'Find and sort': 'i-ri-search-line',
  'Buscar e ordenar': 'i-ri-search-line',
  'How you leave': 'i-ri-logout-box-r-line',
  'Como você sai': 'i-ri-logout-box-r-line',
  'Live counts and hidden worlds': 'i-ri-pulse-line',
  'Contagens ao vivo e mundos escondidos': 'i-ri-pulse-line',
  'KPI cards': 'i-ri-bar-chart-2-line',
  'Cards de KPI': 'i-ri-bar-chart-2-line',
  'Numbers and devices': 'i-ri-phone-line',
  'Números e aparelhos': 'i-ri-phone-line',
  'Card tabs': 'i-ri-folder-line',
  'Abas do card': 'i-ri-folder-line',
  'Inside the task': 'i-ri-checkbox-line',
  'Dentro da tarefa': 'i-ri-checkbox-line',
  'Where you land': 'i-ri-map-pin-line',
  'Onde você cai': 'i-ri-map-pin-line',
  'Inbox AI mode': 'i-ri-robot-line',
  'Modo da IA por caixa': 'i-ri-robot-line',
  Hours: 'i-ri-time-line',
  Horário: 'i-ri-time-line',
});

export const sectionIconFor = title => {
  if (title && SECTION_ICONS[title]) return SECTION_ICONS[title];
  const n = String(title || '').toLowerCase();
  if (/área|areas da tela|screen areas|sidebar|layout|board|quadro/.test(n)) {
    return 'i-ri-layout-line';
  }
  if (/atalho|shortcut|teclado|keyboard/.test(n)) return 'i-ri-keyboard-line';
  if (/óbvio|obvious/.test(n)) return 'i-ri-lightbulb-line';
  if (/lote|bulk|criar e|create and/.test(n)) return 'i-ri-stack-line';
  if (/filtro|filter/.test(n)) return 'i-ri-filter-3-line';
  return DEFAULT_SECTION_ICON;
};

export const screenIconFor = routeName => {
  if (routeName === 'focus_hub') return HUB_SCREEN_ICON;
  const dest = HUB_WORLDS.flatMap(world => world.destinations).find(
    item => item.routeName === routeName
  );
  if (dest?.icon) return dest.icon;
  const world = HUB_WORLDS.find(
    item => item.id === PAGE_COACH[routeName]?.world
  );
  return world?.icon || DEFAULT_SCREEN_ICON;
};

export const worldLabelKeyFor = routeName => {
  if (routeName === 'focus_hub') return 'HUB.TITLE';
  const world = HUB_WORLDS.find(
    item => item.id === PAGE_COACH[routeName]?.world
  );
  return world?.labelKey || '';
};
